<script lang="ts">
    import { spaLink } from "../actions"
    import { navigationCache } from "../store"
    import Icon from "./Icon.svelte"

    export let location: LocationStore = undefined,
        name = ""

    let paths: string[] = []
    const doubleArrow =
        "M10.537 12L6.29699 7.75399C6.20299 7.66065 6.15165 7.54699 6.14299 7.41299C6.13432 7.27899 6.18532 7.15665 6.29599 7.04599C6.40265 6.93932 6.52065 6.88599 6.64999 6.88599C6.77932 6.88599 6.89732 6.93932 7.00399 7.04599L11.392 11.435C11.4793 11.5217 11.5407 11.6107 11.576 11.702C11.6113 11.7933 11.629 11.8927 11.629 12C11.629 12.1073 11.6113 12.2067 11.576 12.298C11.5407 12.3893 11.4793 12.4787 11.392 12.566L7.00399 16.954C6.91065 17.0473 6.79699 17.0983 6.66299 17.107C6.52899 17.1157 6.40665 17.0647 6.29599 16.954C6.18932 16.8473 6.13599 16.7293 6.13599 16.6C6.13599 16.4707 6.18932 16.3527 6.29599 16.246L10.537 12ZM16.637 12L12.397 7.75399C12.303 7.66065 12.2517 7.54699 12.243 7.41299C12.2343 7.27899 12.2853 7.15665 12.396 7.04599C12.5027 6.93932 12.6207 6.88599 12.75 6.88599C12.8793 6.88599 12.9973 6.93932 13.104 7.04599L17.492 11.435C17.5793 11.5217 17.6407 11.6107 17.676 11.702C17.7113 11.7933 17.729 11.8927 17.729 12C17.729 12.1073 17.7113 12.2067 17.676 12.298C17.6407 12.3893 17.5793 12.4787 17.492 12.566L13.104 16.954C13.0107 17.0473 12.897 17.0983 12.763 17.107C12.629 17.1157 12.5067 17.0647 12.396 16.954C12.2893 16.8473 12.236 16.7293 12.236 16.6C12.236 16.4707 12.2893 16.3527 12.396 16.246L16.637 12Z"
    $: if (location?.path?.match(/\/[^\/]+\//)) {
        let _paths: string[] = []
        let _p = location.path
        while (_p || _p.includes("/")) {
            _paths.push(_p)
            // remove last part
            _p = _p.replace(/\/[^\/]+\/?$/, "")
        }
        paths = _paths.reverse()
    } else {
        paths = []
    }
    console.log("name:", name)
</script>

<!-- only for paths with more levels -->
{#if paths.length > 1}
    <nav aria-label="Breadcrumbs" class="breadcrumbs">
        <ol>
            {#each paths as path, i}
                {#if $navigationCache[path] || i == paths.length - 1}
                    <li><a use:spaLink href="{path}">{$navigationCache[path]?.name || name}</a></li>
                {/if}
                {#if paths.length - 1 > i}<Icon path="{doubleArrow}" size="24px" color="var(--grey-500)" />{/if}
            {/each}
        </ol>
    </nav>
{/if}

<style lang="less">
    .breadcrumbs {
        background-color: var(--grey-200);
        display: flex;
        justify-content: center;
        align-items: flex-end;
        height: 100px;
        z-index: 9998;
        margin-top: -54px;
        top: 56px;
        border-radius: 0px 0px 48px 48px;
        position: sticky;
        ol {
            max-width: var(--normal-max-width);
            padding: 0px var(--horizontal-default-margin);
            width: 100%;
            display: flex;
            justify-content: flex-start;
            gap: 10px;
            padding-bottom: 10px;
        }
    }
</style>
